import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175e224a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "rel flex",
  style: {"gap":"24px"}
}
const _hoisted_2 = ["name"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "abs bottom-line" }

import { ref, onMounted, computed } from 'vue'
import { countrys, sourceCountryRef, useSourceCountry } from './index'
import { wait } from '@/plugins/utils'
import { useStore } from 'vuex'
import { COUNTRY } from '@/global'
import { isWhiteHiddenRMB } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [val, change] = useSourceCountry()
const selectedTab = computed(() => val.value !== COUNTRY.KR ? COUNTRY.CN : COUNTRY.KR)
const store = useStore()
const cartSummaryDTOList = computed(() => {
  return store.state.message.cartSummaryDTOList
})
const tabs = countrys

const translateX = ref('0px')
const handle = async (el: any) => {
  await wait(100)
  if (el?.className.includes('active')) {
    const a = el.offsetWidth
    const b = el.offsetLeft
    translateX.value = b + a / 2 + 'px'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (c) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: c.name,
        name: c.name
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-ter sc-tab-item", { active: _unref(selectedTab) === c.name }]),
          onClick: () => _unref(change)(c.name),
          ref: handle
        }, [
          _createElementVNode("img", {
            class: "mr_5",
            src: c.flagIcon,
            alt: ""
          }, null, 8, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(c.cart(_unref(cartSummaryDTOList)?.find((v) => v.goodsCountry === c.name)?.sumCartProductQuantity ?? 0)), 1)
        ], 10, _hoisted_3)
      ], 8, _hoisted_2)), [
        [_vShow, !(c.name === 'KR' && _unref(isWhiteHiddenRMB)())]
      ])
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "block",
        style: _normalizeStyle({ transform: `translateX(${translateX.value})` })
      }, null, 4)
    ])
  ]))
}
}

})